// 展示show more-工具方法
var sv_hideShowmoreDiv = function(divJQ, showmoreButton, showmoreClass, showline){
  let divHeight = divJQ.height();
  let divLineHeight = parseFloat(divJQ.css('line-height'));
  console.log(divHeight,',',divLineHeight)
  if((divHeight/divLineHeight > showline)){
    // 需要显示showmore并绑定显示方法   
    showmoreButton.show();
    divJQ.addClass(showmoreClass)
    showmoreButton.click(function(){
      divJQ.removeClass(showmoreClass);
      showmoreButton.hide();
    });
  }else{
    console.log(divHeight,',',divLineHeight, 'need not')
  }
}
    
// 展示show more-主方法
var sv_hideShowmoreDivs = function(divClass, showmoreBtnClass, showmoreClass, showline){
  let showmoreButton = $(showmoreBtnClass);
  showmoreButton.hide();
  let divs = $(divClass);
  if(divs.length === 1){
    sv_hideShowmoreDiv(divs, showmoreButton, showmoreClass, showline);
  }else if(divs.length > 1){
    for(let key=0;key<divs.length;key++){
      let div = $(divs[key]);
      sv_hideShowmoreDiv(div, showmoreButton, showmoreClass, showline);
    }
  }
}